import React from 'react';
import { T } from '../theme';

export default function Scorecards({ data, onIncompleteClick }) {
  const d = data || {};
  const cards = [
    { label: 'Tamamlanmamış Görev', value: d.incomplete ?? '—', icon: '📋', color: T.blue, onClick: onIncompleteClick },
    { label: 'On-Time Bitirme', value: d.on_time_pct == null ? '—' : `%${d.on_time_pct}`, icon: '⏱️', color: T.green },
    { label: 'Tamamlanan Sprint Point', value: d.sprint_points_done ?? '—', icon: '🎯', color: T.amber },
    { label: 'Bugünkü Toplantı', value: d.meetings_today ?? 0, icon: '📅', color: T.dim, note: d.meetings_placeholder ? 'Takvim bağlanacak' : null },
  ];
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14, marginBottom: 24 }}>
      {cards.map((c, i) => (
        <div key={i} onClick={c.onClick}
          title={c.onClick ? 'Tamamlanmamış görevlere git' : undefined}
          style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: '18px 20px', cursor: c.onClick ? 'pointer' : 'default' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <span style={{ color: T.muted, fontSize: 13 }}>{c.label}</span>
            <span style={{ fontSize: 18 }}>{c.icon}</span>
          </div>
          <div style={{ color: c.color === T.dim ? T.muted : T.text, fontSize: 30, fontWeight: 700, marginTop: 8 }}>{c.value}</div>
          {c.note && <div style={{ color: T.dim, fontSize: 11, marginTop: 2 }}>{c.note}</div>}
        </div>
      ))}
    </div>
  );
}
